// @todo dynamic username
import React from 'react';
import {hideNavigation, navigateTo, showNavigation} from '../action/actions';
import {useDispatch, useSelector} from 'react-redux';
import NavigationLevel from './NavigationLevel';
import NavigationButton from './NavigationButton';
import {publicBuildUrl} from '../config/config';

const Navigation = () => {
    const {app: {level, navigation: {show}, namedPage, room: {name}}} = useSelector((state) => state);
    const dispatch = useDispatch();
    const username = (window.miroCares && window.miroCares.user) ? window.miroCares.user : 'Miro Cares';

    if (show === false) {
        return (
            <div style={styles.closedContainer} onClick={() => dispatch(showNavigation())}>
                <img src={`${publicBuildUrl}/icons/IconMenuOpen.png`} alt={'Open menu'}/>
            </div>
        );
    }

    return (
        <div style={styles.container}>
            <div style={{...styles.flexCentered, ...styles.username}}>{username}</div>

            {name &&
            <div style={{...styles.flexCentered, ...styles.game, flexGrow: 1}}>
                {`Spelnummer: ${name}`}
            </div>}

            <div style={{...styles.flexCentered, flexGrow: 1}}>
                <NavigationLevel level={1} active={level === 1}/>
                <div style={styles.level}>&gt;</div>
                <NavigationLevel level={2} active={level === 2}/>
                <div style={styles.level}>&gt;</div>
                <NavigationLevel level={3} active={level === 3}/>
            </div>
            <NavigationButton active={namedPage === 'rulesOfConduct'} alt={'Communicatie gedragsregels'} icon={`${publicBuildUrl}/icons/IconRulesOfConduct.png`} onClick={() => dispatch(navigateTo('rulesOfConduct'))}/>
            <NavigationButton active={namedPage === 'gameFlow'} alt={'Spelverloop'} icon={`${publicBuildUrl}/icons/IconGameFlow.png`} onClick={() => dispatch(navigateTo('gameFlow'))}/>
            <NavigationButton active={namedPage === 'tool'} alt={'Overzicht stuurwiel'} icon={`${publicBuildUrl}/icons/IconOverzichtStuurwiel.png`} onClick={() => dispatch(navigateTo('tool'))}/>
            <NavigationButton alt={'Sluit menu'} icon={`${publicBuildUrl}/icons/IconMenuClose.png`} onClick={() => dispatch(hideNavigation())}/>
        </div>
    );
}

const styles = {
    closedContainer: {
        cursor: 'pointer',
        position: 'absolute',
        right: 35,
        top: 50,
    },
    container: {
        display: 'flex',
        height: '156px',
        width: '100%',
        flexDirection: 'row',
    },
    username: {
        flexGrow: 1,
        color: '#e41b60',
        fontFamily: 'Ubuntu',
        fontSize: '26px',
        fontWeight: 500,
    },
    game: {
        flexGrow: 1,
        color: '#969696',
        fontFamily: 'Ubuntu',
        fontSize: '13pt',
        fontWeight: 500,
    },
    flexCentered: {
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
    },
    level: {
        color: '#969696',
        paddingRight: '5px',
        fontFamily: 'Ubuntu',
        fontSize: '13pt'
    }
}

export default Navigation;
